import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import { IconButton, Button } from "@material-ui/core";
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import CancelIcon from "../common/icons/cancelIcon";
export const useEditPopupStyles = makeStyles((theme) => ({
    formElementRoot: {
        border: "none",
        fontFamily: "Arial",
        lineHeight: "16px",
        fontSize: "14px",
        display: "flex",
        backgroundColor: theme.palette.background.paper,
    },
    formElement: {
        padding: "16px 0px",
    },
    formElementActivity: {
        padding: "0px",
    },
    formBtn: {
        marginBottom: "auto",
        marginTop: "auto",
        padding: 0,
    },
    formBtnActivity: {
        marginBottom: "auto",
        marginTop: "auto",
        padding: 0,
        textTransform: "none",
    },
    formTitle: {
        "& .MuiTypography-root": {
            fontFamily: "BellSlimBlack",
            fontWeight: 900,
            fontSize: "18px",
            lineHeight: "24px",
            letterSpacing: "0.0018em",
        },
        width: "90%",
    },
    formClose: {
        position: "absolute",
        top: "3px",
        right: "17px",
    },
}));

const Dialog = withStyles({
    paper: {
        position: "absolute",
        width: "100%",
        maxHeight: "100%",
        margin: 0,
        bottom: 0,
    },
})(MuiDialog);

const EditPopup = (props) => {
    let {
        icon,
        title,
        content,
        btnText,
        btnCallback,
        activity = false,
        characterCount = null,
        defaultStepper,
        isOpenPopup = true,
        disabled,
        closePopup = null,
        dialogOnly = false,
        questionType,
    } = props;
    const classes = useEditPopupStyles();
    /** This variable is used to check if the field is a followup comment */
    const isFollowupComment = content?.props?.id?.toLowerCase().includes("comments") ?? false;

    const [open, setOpen] = React.useState(closePopup === null ? false : closePopup);

    useEffect(() => {
        if (closePopup !== null) {
            setOpen(closePopup);
        }
    }, [closePopup]);

    const openEditor = (event) => {
        if (isOpenPopup && (typeof disabled === "undefined" || disabled === false)) {
            setOpen(true);
        }
    };

    const onDone = (event) => {
        if (btnCallback) {
            btnCallback();
        }
        setOpen(false);
    };
    const onClose = (event) => {
        setOpen(false);
    };

    const dialogComponent = () => {
        return (
            <Dialog aria-labelledby="modal-title" aria-describedby="modal-description" open={open} fullWidth className={classes.paper}>
                <DialogTitle className={classes.formTitle} id="form-dialog-title">
                    {title}
                    <IconButton aria-label="close" className={classes.formClose} onClick={onClose}>
                        <CancelIcon className="close-icon" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>{content}</DialogContent>
                {defaultStepper && (
                    <DialogActions>
                        <Button onClick={onDone} color="primary">
                            {btnText ? (
                                btnText
                            ) : (
                                <FormattedMessage id="wo-actions.edit-popup.done" defaultMessage="Done" description="Done Button label" />
                            )}
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        );
    };

    const editButton = () => {
        if (!activity) {
            return (
                <IconButton aria-describedby={"open-editor"} type="button" className={classes.formBtn} onClick={openEditor}>
                    {icon}
                </IconButton>
            );
        }
        return (
            <Button aria-describedby={"open-editor"} className={classes.formBtnActivity} onClick={openEditor}>
                {icon}
            </Button>
        );
    };

    return (
        <>
            {dialogOnly ? (
                dialogComponent()
            ) : (
                <div className={classes.formElementRoot + " " + (activity ? classes.formElementActivity : classes.formElement)}>
                    {icon && editButton()}
                    {dialogComponent()}
                </div>
            )}
        </>
    );
};

export default EditPopup;
